import { Form } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import styled from 'styled-components';

const StyledSearchBox = styled.div`
  position: relative;
  width: fit-content;
  width: 100%;
  input {
    border-radius: 20px !important;
    border: 1px solid #a09898;
  }
  &.large {
    width: 30em;
  }
  .icon {
    position: absolute;
    top: 12%;
    right: 4%;
    color: #4da0fa;
  }
`;

function SearchBox({ value, placeholder, onChange, className }) {
  return (
    <StyledSearchBox className={`input-group ${className ? className : ''}`}>
      <Form.Control placeholder={placeholder} onChange={onChange} value={value} />
      <p className="icon ">
        <FaSearch className="ico" />
      </p>
    </StyledSearchBox>
  );
}

export default SearchBox;
